// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__2b_yH","image":"Header_image__1JMpY","name":"Header_name__1UO0T","info":"Header_info__2vZrm","infoRow":"Header_infoRow__lj950"};